/**
 * Безопасные обёртки над Web Storage.
 *
 * Safari (приватный режим, «Блокировать все cookie», ужатая квота) бросает
 * исключение прямо из `setItem`. Без обёртки такое исключение вылетало из
 * середины флоу авторизации и роняло сохранение сессии целиком — сессия
 * «не запоминалась» именно на айфонах.
 */

export const storageGet = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

/** true — значение реально записано. false — хранилище недоступно. */
export const storageSet = (key: string, value: string): boolean => {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (error) {
    console.warn('[storage] Не удалось записать ключ в localStorage', key, error);
    return false;
  }
};

export const storageRemove = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch {
    /* хранилище недоступно — удалять нечего */
  }
};

export const sessionGet = (key: string): string | null => {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

export const sessionSet = (key: string, value: string): boolean => {
  try {
    sessionStorage.setItem(key, value);
    return true;
  } catch (error) {
    console.warn('[storage] Не удалось записать ключ в sessionStorage', key, error);
    return false;
  }
};

export const sessionRemove = (key: string): void => {
  try {
    sessionStorage.removeItem(key);
  } catch {
    /* хранилище недоступно — удалять нечего */
  }
};

const PROBE_KEY = '__ssmm_storage_probe__';

/**
 * Переживёт ли localStorage перезагрузку страницы.
 * false — приватный режим Safari или запрет хранилища: сессию сохранить не выйдет,
 * пользователю нужно об этом сказать, а не молча терять вход.
 */
export const isStoragePersistent = (): boolean => {
  try {
    localStorage.setItem(PROBE_KEY, '1');
    const ok = localStorage.getItem(PROBE_KEY) === '1';
    localStorage.removeItem(PROBE_KEY);
    return ok;
  } catch {
    return false;
  }
};

/** Нет сети — ходить на бэк бессмысленно, и уж точно нельзя считать токен мёртвым. */
export const isOffline = (): boolean => {
  try {
    return navigator.onLine === false;
  } catch {
    return false;
  }
};
